import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';

export const CardSkeleton = styled(Skeleton)`
  width: 300px;
  height: 200px;
  margin: 0px 0px;
  border-radius: var(--border20);
  cursor: pointer;

  @media (max-width: 400px) {
    height: 140px;
  }
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;

  .card-wrapper__description-container {
    display: flex;
    flex-direction: column;

    padding: 5px 5px 10px;
    color: var(--purple27);

    background-color: #e5e5e5;
    border-radius: 0 0 5px 5px;

    border-top: 1px solid var(--purple27);
  }

  .card-wrapper__title {
    font-size: 1rem;
    font-weight: bold;

    max-width: 280px;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .card-wrapper__description {
    width: 100%;
    max-width: 280px;

    font-size: 0.8rem;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const Card = styled.img`
  display: block;
  width: 100%;

  max-width: 415px !important;
  max-height: 292px !important;

  /* height: 200px !important; */
  margin: 0;

  border-radius: 5px;

  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2);

  object-fit: cover;

  cursor: pointer;
  transition: all 1s;
  opacity: 0;
`;

export const ListCardsWithouSlider = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
  margin: 0 20px;
  > img {
    margin: 0 20px;
  }

  @media (max-width: 1060px) {
    > img {
      margin: 20px 20px;
    }
  }

  @media (max-width: 720px) {
    > img {
      width: 270px;
    }
    margin: 0px;
  }
`;
